import { render, staticRenderFns } from "./ImgOrientationModal.vue?vue&type=template&id=a28d32b6&"
import script from "./ImgOrientationModal.vue?vue&type=script&lang=js&"
export * from "./ImgOrientationModal.vue?vue&type=script&lang=js&"
import style0 from "./ImgOrientationModal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports